import { LocalStorageEnum } from '@uigy/shared/enums/storageKeys.enum';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LayoutModule } from '@uigy/core/modules/layout/layout.module';
import { GraphQLModule } from '@uigy/graphql.module';
import { JwtModule } from '@auth0/angular-jwt';
import { StoreModule } from '@ngrx/store';
import { effects, reducers } from '@uigy/store';
import { EffectsModule } from '@ngrx/effects';
import { IframeComponent } from '@uigy/core/components/iframe/iframe.component';
import { BrowserDynamicTestingModule } from '@angular/platform-browser-dynamic/testing';
import { RouterTestingModule } from '@angular/router/testing';
import {} from '@angular/common/http/testing';
import { BrowserModule } from '@angular/platform-browser';
import {} from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { ReloadComponent } from '@uigy/core/components/reload/reload.component';
import { UnauthorizedComponent } from '@uigy/core/components/unauthorized/unauthorized.component';

export function jwtTokenGetter() {
  return localStorage.getItem(LocalStorageEnum.accessToken);
}

export const CoreModuleDeclarations = [
  IframeComponent,
  ReloadComponent,
  UnauthorizedComponent,
];

export const CoreExportModules = [
  CommonModule,
  BrowserAnimationsModule,
  LayoutModule,
  GraphQLModule,
  JwtModule,
  StoreModule,
  EffectsModule,
];

export const CoreImportModules = [
  BrowserModule,
  CommonModule,
  BrowserAnimationsModule,
  LayoutModule,
  GraphQLModule,
  JwtModule.forRoot({
    config: {tokenGetter: jwtTokenGetter}
  }),
  StoreModule.forRoot(reducers, {
    runtimeChecks: {
      strictActionImmutability: false,
      strictActionSerializability: false,
      strictActionWithinNgZone: false,
      strictStateImmutability: false,
      strictStateSerializability: false
    }
  }),
  EffectsModule.forRoot([...effects]),
];

export const CoreTestingModules = [
  RouterTestingModule,
  ReactiveFormsModule,
  BrowserDynamicTestingModule,
  RouterTestingModule,
];

